var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f2a99a6781c29eafeeb20fb77c05b2ff405cd2a8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["viaventuro-fe@viaventuro"]={id:"f2a99a6781c29eafeeb20fb77c05b2ff405cd2a8"};
      